import React from 'react'
import { DeltaPill, Icon } from './PulseCategoryList'
import { useTranslation } from 'react-i18next'

function VsLastWeekCard({ groups = [], compareLabel = 'vs last week' }) {
    const { t } = useTranslation()
    return (
        <div className="w-[360px] flex-shrink-0 bg-white rounded-2xl py-[20px] px-[22px] border border-lightBG flex flex-col gap-[14px] shadow-[0_12px_30px_rgba(45,43,69,0.06),0_1px_0_rgba(45,43,69,0.02)]">
            {/* Header */}
            <div>
                <div className="font-bold text-[16px] text-darkenPurple">{t('Latest')} {t(compareLabel)}</div>
                <div className="font-medium text-[12px] text-mudPurple">{t('Direction of change')}</div>
            </div>

            {/* List */}
            <div className="flex flex-col gap-[10px]">
                {!groups.length && <div className="py-4 text-center text-mudPurple font-medium text-[13px]">{t('thereIsNoDataToShow')}</div>}
                {groups.map((group) => (
                    <div
                        key={group.key}
                        className="
                            flex items-center justify-between
                            py-[10px] px-[12px]
                            rounded-[12px]
                            bg-[#F8F8FB]
                        "
                    >
                        <div className="flex items-center gap-[10px]">
                            <span className="w-[10px] h-[10px] rounded-full" style={{ background: group.color }} />
                            <span className="font-semibold text-[13px] text-darkenPurple">{t(group.label)}</span>
                        </div>

                        {group.delta !== null && group.delta !== undefined ? <DeltaPill delta={group.delta} /> : <span className="text-mudPurple text-[12px] font-medium">—</span>}
                    </div>
                ))}
            </div>

            {/* Footer */}
            <div className="pt-2 border-t border-lightBG flex flex-col gap-[6px]">
                <div className="flex items-center gap-2 font-semibold text-[12px] text-[#2B8C50]">
                    <Icon name="arrowUp" size={14} stroke={2.4} />
                    <span>{t('Improvement')}</span>
                </div>

                <div className="flex items-center gap-2 font-semibold text-[12px] text-[#C73340]">
                    <Icon name="arrowDown" size={14} stroke={2.4} />
                    <span>{t('Decline')}</span>
                </div>
            </div>
        </div>
    )
}

export default VsLastWeekCard
